module.exports = __webpack_public_path__ + "img/smile.3b76c54b.svg";